import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { naira, compactNaira } from "../../lib/format";
import { C } from "./AccountingLayout";

export default function AccountsReceivable() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/reports/accounts-receivable").then(setD).catch(() => {}); }, []);
  if (!d) return <div className="rounded-xl bg-white border p-8 text-center" style={{ borderColor: C.border, color: C.softMuted }}>Loading…</div>;
  return (
    <div className="space-y-4" data-testid="ar-page">
      <div className="rounded-xl bg-white border p-5" style={{ borderColor: C.border }}>
        <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: C.muted }}>Total Outstanding</div>
        <div className="font-brand font-bold text-4xl mt-1" style={{ color: C.burgundy }}>{compactNaira(d.total)}</div>
        <div className="text-[12px] mt-1" style={{ color: C.softMuted }}>Across {d.rows.length} order{d.rows.length !== 1 ? "s" : ""} with unpaid balances</div>
      </div>
      <div className="rounded-xl bg-white border overflow-hidden" style={{ borderColor: C.border }}>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] uppercase tracking-widest border-b" style={{ color: C.softMuted, borderColor: C.borderSoft }}>
              <th className="py-3 px-4">Order</th><th className="py-3 px-3">Customer</th><th className="py-3 px-3">Date</th>
              <th className="py-3 px-3 text-right">Total</th><th className="py-3 px-4 text-right">Outstanding</th>
            </tr></thead>
            <tbody>{d.rows.length === 0 ? <tr><td colSpan={5} className="py-8 text-center" style={{ color: C.softMuted }}>No outstanding receivables.</td></tr> : d.rows.map((r, i) => (
              <tr key={i} className="border-b" style={{ borderColor: C.borderSoft }}>
                <td className="py-2.5 px-4 font-semibold" style={{ color: C.burgundy }}>{r.order_number}</td>
                <td className="py-2.5 px-3 text-[12.5px]" style={{ color: C.text }}>{r.customer}</td>
                <td className="py-2.5 px-3 text-[12px]" style={{ color: C.muted }}>{(r.date || "").slice(0, 10)}</td>
                <td className="py-2.5 px-3 text-right tabular-nums">{naira(r.total)}</td>
                <td className="py-2.5 px-4 text-right tabular-nums font-brand font-bold" style={{ color: C.burgundy }}>{naira(r.balance)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
